var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 48,
    viewBox: "0 0 40 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12.4c0-2.24 0-3.36.44-4.216a4.02 4.02 0 0 1 1.766-1.748C3.07 6 4.202 6 6.465 6h7.721c1.45 0 2.176 0 2.816.219a4.048 4.048 0 0 1 1.51.923c.484.47.808 1.112 1.457 2.396L22.222 14H0v-1.6Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M0 14h30.4c3.36 0 5.04 0 6.324.654a6 6 0 0 1 2.622 2.622C40 18.56 40 20.24 40 23.6v8.8c0 3.36 0 5.04-.654 6.324a6 6 0 0 1-2.622 2.622C35.44 42 33.76 42 30.4 42H9.6c-3.36 0-5.04 0-6.324-.654a6 6 0 0 1-2.622-2.622C0 37.44 0 35.76 0 32.4V14Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFolder);
export default __webpack_public_path__ + "static/media/icon-folder.b1524354868744fbb0debf354c63a12e.svg";
export { ForwardRef as ReactComponent };